const UtilsTypes = {
    SYSTEM_COMBINATIONS: 'systemCombinations',
    OUTCOME_LABEL: 'outcomeLabel',
    ODDS_UTILS: 'oddsUtils',
    FORMAT_DECIMAL_ODDS: 'formatDecimalOdds',
    FORMAT_ODDS: 'formatOdds',
    GET_AMERICAN_ODDS: 'getAmericanOdds',
    GET_FRACTIONAL_ODDS: 'getFractionalOdds',
    BETOFFER_LABEL: 'betOfferLabel',
    POTENTIAL_PAYOUT: 'potentialPayout',
    ORIGINAL_POTENTIAL_PAYOUT: 'originalPotentialPayout',
    POTENTIAL_PAYOUT_SYSTEM: 'potentialPayoutSystem',
    FORMAT_NUMBER_WITH_CURRENCY: 'formatNumberWithCurrency',
    FORMAT_CURRENCY_WITH_UNICODE_SYMBOL: 'formatCurrencyWithUnicodeSymbol',
};

export { UtilsTypes };
